import OtherTransactionDocuments from "./other-transaction-documents";

export default OtherTransactionDocuments;
